"use client";

import Image from "next/image";
import { cn } from "~/lib/utils";
import { buttonVariants } from "../ui/button";
import { useTranslations } from "~/hooks/useTranslations";
import Link from "next/link";
import { generatePath } from "~/lib/client/utils";
import { Paths } from "~/lib/Paths";
import dayjs from "dayjs";
import { Month } from "~/lib/definitions";
import { Minus } from "lucide-react";
import { isDtmShop } from "~/lib/client/isDtmShop";
import { useParams } from "next/navigation";

const VipSeriesId = "OQQQPYACGVHTMPHAQAVM74FLQE";
const VipSeriesName = "DTM VIP 2025";
const VipStartDate = dayjs()
  .tz("CET")
  .year(2025)
  .month(Month.April)
  .date(25)
  .startOf("day");

const VipEndDate = dayjs()
  .tz("CET")
  .year(2025)
  .month(Month.October)
  .date(3)
  .endOf("day");

export function DtmVipBanner(): JSX.Element {
  const d = useTranslations();

  const { seriesId } = useParams();

  return isDtmShop() && seriesId !== VipSeriesId ? (
    <li
      key={VipSeriesId}
      className="mb-8 flex w-full flex-col flex-nowrap gap-4 md:flex-row"
    >
      <div className="flex flex-row-reverse flex-nowrap justify-between gap-4 md:flex-row md:justify-start">
        <div className="flex flex-col items-center">
          <div className="flex w-[100px] shrink-0 flex-col items-center justify-center">
            <p className="w-full text-center text-xl font-black">
              {VipStartDate.format("DD")}
            </p>
            <p className="w-full text-center text-sm">
              {VipStartDate.format("MMMM YY")}
            </p>
          </div>
          <span>
            <Minus />
          </span>
          <div className="flex w-[100px] shrink-0 flex-col items-center justify-center">
            <p className="w-full text-center text-xl font-black">
              {VipEndDate.format("DD")}
            </p>
            <p className="w-full text-center text-sm">
              {VipEndDate.format("MMMM YY")}
            </p>
          </div>
        </div>
        <Image
          src="https://imagedelivery.net/9KVenP8ut0QanvKfKJwZ3g/30697eb2-f74b-4a44-0c8b-d2762bfd7400/XXL"
          alt="vip image"
          width={200}
          height={200}
          className="aspect-auto max-w-[200px] shrink-0 rounded-md md:aspect-video"
        />
      </div>
      <div className="w-full self-center">
        <Link
          href={generatePath(Paths.SERIES, { seriesId: VipSeriesId })}
          className="font-bold hover:underline"
          prefetch={false}
        >
          {VipSeriesName}
        </Link>
      </div>
      <div className="flex shrink-0 flex-col items-center justify-center gap-2 px-0 md:gap-4 md:px-4">
        <Link
          className={cn(
            buttonVariants({ variant: "outline" }),
            "w-full text-black",
          )}
          href={generatePath(Paths.SERIES, { seriesId: VipSeriesId })}
          prefetch={false}
        >
          {d.more_information}
        </Link>
      </div>
    </li>
  ) : (
    <></>
  );
}
